import React, { useEffect, useState } from 'react';
type ProgressBarProps = {
  duration: number;
  onComplete?: () => void;
  skipToEnd?: boolean;
  messages?: string[];
};
export const ProgressBar = ({
  duration,
  onComplete,
  skipToEnd,
  messages = []
}: ProgressBarProps) => {
  const [progress, setProgress] = useState(0);
  const [showDebug, setShowDebug] = useState(false);
  useEffect(() => {
    if (skipToEnd) {
      setProgress(90);
      const timeout = setTimeout(() => {
        setProgress(100);
        onComplete?.();
      }, 500);
      return () => clearTimeout(timeout);
    }
    const startTime = Date.now();
    const interval = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const newProgress = Math.min(elapsed / duration * 100, 100);
      setProgress(newProgress);
      if (newProgress >= 100) {
        clearInterval(interval);
        onComplete?.();
      }
    }, 100);
    return () => clearInterval(interval);
  }, [duration, skipToEnd]);
  return <div className="space-y-2" data-id="element-848">
      <div className="w-full bg-[#E5C1A9]/20 rounded-full h-2 overflow-hidden cursor-pointer" onDoubleClick={() => setShowDebug(!showDebug)} data-id="element-849">
        <div className="h-full bg-[#D4A088] transition-all duration-500 ease-out" style={{
        width: `${progress}%`
      }} data-id="element-850" />
      </div>
      {showDebug && messages.length > 0 && <div className="mt-4 bg-white/80 backdrop-blur-sm rounded-lg p-4 max-h-48 overflow-y-auto" data-id="element-851">
          <div className="space-y-1 font-mono text-xs text-[#6B4B3E]/75" data-id="element-852">
            {messages.map((message, index) => <div key={index} className="py-0.5" data-id="element-853">
                {message}
              </div>)}
          </div>
        </div>}
    </div>;
};